// libraries
import { useHistory } from "react-router-dom";

// icons
import { BsPlusCircleFill } from "react-icons/bs";

const MealPlanItem = ({ data, setShowDrawer, index, setDrawer, mealPlan }) => {
  // use history
  const history = useHistory();

  return (
    <div
      style={{ cursor: "pointer" }}
      className="d-flex flex-column meal-plan-card "
      onClick={() => history.push(`/recipes/${data.category}/${data.uuid}`)}
    >
      <BsPlusCircleFill
        className="meal-plan-replace"
        onClick={(e) => {
          if (e.stopPropagation) e.stopPropagation();
          setShowDrawer(true);
          setDrawer(mealPlan, data.uuid, index, data.category);
        }}
      />
      <div
        className="meal-plan-card-image"
        style={{
          backgroundImage: `url(${data.image})`,
        }}
      >
        <div className="meal-plan-card-time">
          <span>
            <strong>30</strong> min
          </span>
        </div>
      </div>
      <p className="meal-plan-card-title">{data.recipe}</p>
    </div>
  );
};

export default MealPlanItem;
